/** @format */

const template = `
<div ng-if="!$ctrl.shortVersion">
  <div class="row">
    <div class="col-6 form-group-mimic">
      <h4
        >{{'STUDENT_APPLICATIONS.STUDENT' | translate }}
        <sis-external-link ng-if="$ctrl.studentLink" [href]="$ctrl.studentLink">
          <span>{{'STUDENT_APPLICATIONS.OPEN_STUDENT_INFO' | translate }}</span>
        </sis-external-link>
      </h4>
      <span>{{$ctrl.application.student.fullName}} ({{$ctrl.application.student.studentNumber}})</span>
    </div>
    <div class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.STUDY_RIGHT</h4>
      <span>{{$ctrl.education.name | localizedString}}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.SUGGESTED_ATTAINMENT_NAME</h4>
      <span>{{$ctrl.application.name}}</span>
    </div>
    <div class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.APPLICATION_ARRIVED</h4>
      <span>{{$ctrl.application.creationTime | localDateFormat}}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.DEGREE_PROGRAMME</h4>
      <span>{{$ctrl.application.degreeProgramme.name | localizedString}}</span>
    </div>
    <div class="col-12 col-sm-6 form-group-mimic">
      <h4 ng-if="$ctrl.childNamingCode.urn !== 'urn:code:education-option-naming-type:empty'">
        {{ $ctrl.childNamingCode.name | localizedString }}
      </h4>
      <h4 ng-if="!$ctrl.childNamingCode || $ctrl.childNamingCode.urn === 'urn:code:education-option-naming-type:empty'" translate>
        PLAN_STUDY_RIGHT_MODAL.EDUCATION_OPTION
      </h4>
      <text-with-default-missing-value value="$ctrl.childModule.name | localizedString" is-option="true"> </text-with-default-missing-value>
    </div>
    <div class="col-6 form-group-mimic">
      <h4
        >{{'STUDENT_APPLICATIONS.PLANNED_LOCATION' | translate}}
        <sis-external-link ng-if="$ctrl.studyPlanLink" [href]="$ctrl.studyPlanLink">
          <span>{{'STUDENT_APPLICATIONS.OPEN_STUDENT_STUDY_PLAN' | translate }}</span>
        </sis-external-link>
      </h4>
      <span>{{$ctrl.plannedParentModule.name | localizedString}}</span>
    </div>
    <div class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.PREFERRED_LANGUAGE</h4>
      <text-with-default-missing-value
        value="$ctrl.getLanguageName($ctrl.application.student.preferredLanguageUrn) | localizedString"
        is-option="true">
      </text-with-default-missing-value>
    </div>
  </div>
  <div class="row">
    <div class="col-6 form-group-mimic">
      <h4 translate>STUDENT_APPLICATIONS.CONTACT_INFO.EMAIL</h4>
      <span>{{$ctrl.application.student.primaryEmail}}</span>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 form-group-mimic">
    <h4 translate>STUDENT_APPLICATIONS.CUSTOM_ATTAINMENT.APPLICATION_RATIONALE</h4>
    <span class="text-area-static">{{$ctrl.application.applicationRationale}}</span>
  </div>
  <div class="col-12 form-group-mimic">
    <h4 translate>STUDENT_APPLICATIONS.CUSTOM_ATTAINMENT.RESPONSIBLE_TEACHER</h4>
    <span>{{$ctrl.application.responsibleTeacher}}</span>
  </div>
  <div class="col-12 col-md-6 form-group-mimic">
    <h4 translate>STUDENT_APPLICATIONS.CUSTOM_ATTAINMENT.PLANNED_CREDITS</h4>
    <span>{{$ctrl.application.plannedCredits}} {{'STUDENT_APPLICATIONS.CUSTOM_ATTAINMENT.CREDITS' | translate}}</span>
  </div>
  <div class="col-12 col-md-6 form-group-mimic">
    <h4 translate>STUDENT_APPLICATIONS.ATTAINMENT_LANGUAGE</h4>
    <span><localized-urn-name-display urn="$ctrl.application.attainmentLanguage"></localized-urn-name-display></span>
  </div>
  <div class="col-12 form-group-mimic">
    <h4 translate>STUDENT_APPLICATIONS.CUSTOM_ATTAINMENT.ATTAINMENT_DESCRIPTION</h4>
    <span class="text-area-static">{{$ctrl.application.attainmentDescription}}</span>
  </div>
</div>
<div class="row" ng-if="$ctrl.application.customStudyDraft">
  <div class="col-12 col-md-12">
    <h3 translate="STUDENT_APPLICATIONS.CUSTOM_STUDY_DRAFT_THAT_APPLICATION_IS_BASED_ON">Opintoluonnos, jonka pohjalta hakemus on tehty</h3>
    <div class="row">
      <div class="col-6 form-group-mimic">
        <label translate="CUSTOM_STUDY_DRAFT.NAME">Opinnon nimi</label>
        <p class="form-control-static">{{ $ctrl.application.customStudyDraft.name }}</p>
      </div>
      <div class="col-6 form-group-mimic">
        <label translate="CUSTOM_STUDY_DRAFT.CREDITS">Opinnon suunniteltu laajuus</label>
        <p class="form-control-static">{{ $ctrl.application.customStudyDraft.credits }} <span translate>CREDITS</span></p>
      </div>
      <div class="col-6 form-group-mimic">
        <label translate="CUSTOM_STUDY_DRAFT.LOCATION">Opinnon suunniteltu suorituspaikka</label>
        <p class="form-control-static">{{ $ctrl.application.customStudyDraft.location }}</p>
      </div>
      <div class="col-6 form-group-mimic">
        <label translate="CUSTOM_STUDY_DRAFT.DESCRIPTION">Tavoiteltavan osaamisen kuvaus</label>
        <p class="form-control-static">{{ $ctrl.application.customStudyDraft.description }}</p>
      </div>
    </div>
  </div>
</div>
`;
export default template;
